import axiosInstance from "@/api/axiosInstance";
import { LogEngagementFormData } from "@/modules/coaching/types/validation";

export interface LogEngagementResponse {
  id: number;
  companyId: number;
  eventType: 'call' | 'email' | 'meeting' | 'general';
  eventNotes: string | null;
  eventTimestamp: Date;
}

export const logEngagement = async (
  data: LogEngagementFormData
): Promise<LogEngagementResponse> => {
  const response = await axiosInstance.post(
    `/api/private/coaching/companies/${data.companyId}/engagement`,
    {
      eventType: data.eventType,
      eventNotes: data.eventNotes
    }
  );
  return response.data;
};
